import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { SEARCH_VIEW_ALL } from 'src/app/constants';
import { CURRENCY } from '../../environments/environment';
import { HelperService } from '../helper.service';
import {
  RATE_TYPE_FIXED, RATE_TYPE_PER_MONTH,
  RATE_TYPE_FREE, RATE_TYPE_PER_CLASS, RATE_TYPE_PER_HOUR
} from 'src/app/constants';
import {
  SEARCH_RESULT_KEYWORDS, SEARCH_RESULT_KEYWORD_CONTENT,
  SEARCH_RESULT_KEYWORD_DESC, SEARCH_RESULT_KEYWORD_DESC_CONTENT, SEARCH_TITLE
} from 'src/app/seoconstants';
import 'rxjs/add/operator/filter';
import { exit } from 'process';
import { Title, Meta } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { filter, map, takeUntil } from 'rxjs/operators';
import { isNil } from '../utils';

@Component({
  selector: 'app-class-search-result',
  templateUrl: './class-search-result.component.html',
  styleUrls: ['./class-search-result.component.scss']
})
export class ClassSearchResultComponent implements OnInit {

  destroy$ = new Subject<boolean>();

  serviceTypeList: any;
  speciallityList: any;
  vendorTypeId: string;
  vendorTypeName: string;
  category: string;
  category1: string;
  specialityId: string;
  mode: string;
  searchList: [];
  searchlength: number;
  imgPlaceholder = './assets/images/noimage.png';
  text2: string;
  businessspecialityList: [];
  currency: string;
  businessList = [];
  businessList1 = [];
  businessImages = [];
  keyword: string;
  businessListSubset: string;
  classID: string;
  isFilter;
  title: string;
  keywords: string;
  keywordcontent: string;
  desc: string;
  desccontent: string;



  state: any;
  newState: any;
  preState: any;
  checkState = false;

  state1: any;
  newState1: any;
  preState1: any;
  checkState1 = false;

  searchLocation: {lat: number, lang: number} = {lat: null, lang: null};


  options = [
    { name: 'dormant' },
    { name: 'active' },
    { name: 'finished' }
  ];

  options1 = [
    { name: 'dormant' },
    { name: 'active' },
    { name: 'finished' }
  ];

  setState(state: any) {
    this.preState = this.newState;
    this.newState = state
    this.checkState = true;
  }

  setState1(state1: any) {
    this.preState1 = this.newState1;
    this.newState1 = state1
    this.checkState1 = true;
  }

  selectedOption(option: any) {
    return this.newState === option;
  }

  selectedOption1(option1: any) {
    return this.newState1 === option1;
  }

  yes() {
    this.state = this.newState;
    this.checkState = false;
  }

  no() {
    this.checkState = false;
    this.newState = this.preState;

    this.checkState1 = false;
    this.newState1 = this.preState1;
  }

  no1() {
    this.checkState1 = false;
    this.newState1 = this.preState1;
  }

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService: HelperService,
    private titleService: Title, private metaService: Meta

  ) {
    this.category = this.activatedRoute.snapshot.paramMap.get('category');
    this.specialityId = this.activatedRoute.snapshot.paramMap.get('specialityId');

    this.activatedRoute.queryParams
      .pipe(
        filter(params => !isNil(params.mode)),
        takeUntil(this.destroy$)
      )
      .subscribe(params => {
        this.mode = params.mode;
        console.log('[mode] : ', this.mode);
        
      }
    );

    this.helperService.searchLocationOb$
    .pipe(
      filter(v => !!v),
      takeUntil(this.destroy$)
    )
    .subscribe(v => {
      this.searchLocation = {
        lat: v.geometry.location.lat(),
        lang: v.geometry.location.lng(),
      }
    })
  }

  ngOnInit() {


    this.isFilter = "0";

    this.title = SEARCH_TITLE;
    this.keywords = SEARCH_RESULT_KEYWORDS;
    this.keywordcontent = SEARCH_RESULT_KEYWORD_CONTENT;
    this.desc = SEARCH_RESULT_KEYWORD_DESC;
    this.desccontent = SEARCH_RESULT_KEYWORD_DESC_CONTENT;
    this.text2 = SEARCH_VIEW_ALL;
    this.currency = CURRENCY;


    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: this.keywords, content: this.keywordcontent },
      { name: this.desc, content: this.desccontent },
      { name: 'robots', content: 'index, follow' }
    ]);



    let vendata = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),

    }

    this.apiService.getVenDetails(vendata).subscribe((res: any) => {


      this.serviceTypeList = res.data.venDetails.data;




    });

    /*let classTypeData = {

      token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
    }*/

    /*this.apiService.classType(classTypeData).subscribe((res:any)=>{
     

    });*/
    if (this.specialityId == "undefined") {

      let classSearchData = {

        ...this.searchLocation,
        serviceTypeID: this.category,
        mode: this.mode
      }

      this.apiService.classSearchList(classSearchData).subscribe((res: any) => {

        this.searchList = res.data.classBusinessData.data.businessDetails;
        this.searchlength = this.searchList.length;
        this.businessspecialityList = res.data.classBusinessData.data.businessSpeciality;

      })

    }
    else if (this.mode == "undefined") {

      let classSearchData = {

        ...this.searchLocation,
        serviceTypeID: this.category,
        specialityID: this.specialityId,
      }

      this.apiService.classSearchList(classSearchData).subscribe((res: any) => {
        this.searchList = res.data.classBusinessData.data.businessDetails;
        this.searchlength = this.searchList.length;
        this.businessspecialityList = res.data.classBusinessData.data.businessSpeciality;


      })


    }

    else {


      let classSearchData = {

        ...this.searchLocation,
        serviceTypeID: this.category,
        specialityID: this.specialityId,
        mode: this.mode
      }

      this.apiService.classSearchList(classSearchData).subscribe((res: any) => {
        this.searchList = res.data.classBusinessData.data.businessDetails;
        this.businessList1 = res.data.classBusinessData.data.businessDetails;
        this.searchlength = this.searchList.length;

      })

    }


  }

  search() {


    if (this.specialityId == "undefined") {
      let classSearchData = {

        ...this.searchLocation,
        serviceTypeID: this.category1,
        mode: this.mode

      }

      this.apiService.classSearchList(classSearchData).subscribe((res: any) => {

        this.searchList = res.data.classBusinessData.data.businessDetails;
        this.searchlength = this.searchList.length;
        this.businessspecialityList = res.data.classBusinessData.data.businessSpeciality;


      })
    }

    else {

      let classSearchData = {

        ...this.searchLocation,
        serviceTypeID: this.category1,
        specialityID: this.specialityId,
        mode: this.mode

      }

      this.apiService.classSearchList(classSearchData).subscribe((res: any) => {

        this.searchList = res.data.classBusinessData.data.businessDetails;
        this.searchlength = this.searchList.length;
        this.businessspecialityList = res.data.classBusinessData.data.businessSpeciality;


      })
    }

  }

  getShortName(fullName) {
    return fullName.charAt(0);
  }

  profile(venId, id) {
    //this.router.navigateByUrl(`/classprofile/`+ venId + `/`+ id);
    this.router.navigateByUrl(`/classprofile/` + venId + `/` + id);
  }

  filter() {
    this.isFilter = "1";
    this.specialityId = "undefined";

  }

  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
    else if (priceRateTypeId === 3) {
      return RATE_TYPE_FREE;
    }
    else if (priceRateTypeId === 4) {
      return RATE_TYPE_PER_CLASS;
    }
    else
      return RATE_TYPE_PER_HOUR;
  }

  speciallity() {
    this.specialityId = "undefined";
    let specialData = {
      //token:localStorage.getItem("token_data"),
      // userID:localStorage.getItem("userID"),
      vendorType: this.category1
    }
    this.apiService.getspetialityDetails(specialData).subscribe((res: any) => {

      this.speciallityList = res.data.venSplDetails.data;

      this.speciallityList.forEach(function (value, key) {

      })

    });


  }

  onSearch() {
    this.businessList = [];
    this.businessImages = [];

    if (this.keyword) {

      for (let i = 0; i < this.businessList1.length; i++) {
        const el = this.businessList1[i];
        if (el.businessName.toLowerCase().includes(this.keyword.toLowerCase()) ||
          el.packageName.toLowerCase().includes(this.keyword.toLowerCase())) {
          this.businessList.push(el);

        }
      }

    } else {
      this.businessList = [...this.businessList1];

    }



  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }


}




